import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { installStoreAds, trackStoreEvent } from "@/lib/storeAds";

/** Loads Google, YouTube (Google Ads tag), and Meta scripts, then records each route. */
export default function StoreAds({ ads }) {
  const { pathname } = useLocation();
  const key = JSON.stringify(ads || {});

  useEffect(() => {
    installStoreAds(ads);
  }, [key, ads]);

  useEffect(() => {
    trackStoreEvent("page_view", { page_path: pathname });
  }, [pathname, key]);

  return null;
}
